if (!customElements.get('sticky-add-to-cart')) {
  class StickyAddToCart extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.section = document.getElementById(`shopify-section-${this.sectionId}`);
      this.productForm = this.section.querySelector(`product-form[data-section-id="${this.sectionId}"]`);
      this.variantPicker = this.section.querySelector(`variant-picker[data-section="${this.sectionId}"]`);
      this.footer = document.querySelector('footer');
      this.isActive = false;
      let lastY = 0;

      // Observer for product form to show/hide sticky ATC
      this.observer = new IntersectionObserver(([entry]) => {
        const currentY = entry.boundingClientRect.y;
        const scrollingDown = currentY < lastY;
        lastY = currentY;

        if (!entry.isIntersecting && scrollingDown) {
          this.isActive = true;
          this.checkFooterIntersection();
        } else {
          this.isActive = false;
          this.classList.remove('sticky-atc--active');
        }
      });

      this.observer.observe(this.productForm);

      // Check footer intersection on scroll
      this.handleScroll = () => {
        if (this.isActive && this.footer) {
          this.checkFooterIntersection();
        }
      };
      window.addEventListener('scroll', this.handleScroll, { passive: true });
    }

    checkFooterIntersection() {
      if (!this.footer || !this.isActive) return;

      const stickyAtcRect = this.getBoundingClientRect();
      const footerRect = this.footer.getBoundingClientRect();
      
      // Check if footer top is at or above sticky ATC bottom
      if (footerRect.top <= stickyAtcRect.bottom) {
        this.classList.remove('sticky-atc--active');
      } else {
        this.classList.add('sticky-atc--active');
      }
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
      if (this.handleScroll) {
        window.removeEventListener('scroll', this.handleScroll);
      }
    }
  }

  customElements.define('sticky-add-to-cart', StickyAddToCart);
}
